import BaseSectionTitle from "src/components/layout/BaseSectionTitle";
import { ApplicationSummary } from "src/pages/product/hooks/useUsageApplication";
import { formatPhoneNumber } from "src/utils";

const UsageApplicationContractorSection = ({ applicationSummary }: { applicationSummary: ApplicationSummary }) => {
  return (
    <div>
      <BaseSectionTitle title="계약자 정보" className="py20" noHashLink />
      <div className="flex-center">
        <section className="contents-container__grid">
          <div className="contents-container__grid-index">
            <p>이름(닉네임)</p>
          </div>
          <div className="contents-container__grid-contents">
            <p>{applicationSummary.contractorInfo.memberName || "-"}</p>
          </div>
        </section>
        <section className="contents-container__grid">
          <div className="contents-container__grid-index"></div>
        </section>
      </div>
      <div className="flex-center">
        <section className="contents-container__grid">
          <div className="contents-container__grid-index">
            <p>휴대폰</p>
          </div>
          <div className="contents-container__grid-contents">
            <p>{formatPhoneNumber(applicationSummary.contractorInfo.memberPhoneNumber) || "-"}</p>
          </div>
        </section>
        <section className="contents-container__grid">
          <div className="contents-container__grid-index">
            <p>이메일</p>
          </div>
          <div className="contents-container__grid-contents">
            <p>{applicationSummary.contractorInfo.memberEmail || "-"}</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default UsageApplicationContractorSection;
